import React from "react";
import { useAuth } from './StAuthGiver';
import { Button } from "react-bootstrap";
import { useEffect } from 'react';
import { useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import Cookies from 'js-cookie';
import { Spinner } from 'react-bootstrap';
const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined ? 'aws' : 'staging');
// const loginURL = (WhichEnv == 'aws') ? 'https://dashboard.turbosteed.com' : 'https://192.168.1.210:3000';
const loginURL = process.env.REACT_APP_TURBO_LOGIN_URL;
const Tdebug = (WhichEnv != 'aws');

function StAuthCallback() {


    const location = useLocation();
    //const history = useHistory();
    const navigate = useNavigate();
    const { user, token } = useAuth();
    const { loginAction, logOut } = useAuth();

	// On dashboard.turbosteed.com/callback
//const urlParams = new URLSearchParams(window.location.search);
//const state = urlParams.get('state');

//console.log(state);

//const trackingData = JSON.parse(atob(state));

//console.log(trackingData);

    console.log("Path params:", useParams());
    console.log("Full location object:", location);

    const queryParams = new URLSearchParams(location.search);

    console.log("state variable is:" + queryParams.get("state"));
//    console.log("state variable is:" + JSON.parse(atob(queryParams.get("state"))));

    localStorage.setItem('TemplateId', queryParams.get("state"))


    // To prevent this from loading twice.
    const isMounted = useRef(false);


    const [authRequested, setAuthRequested] = useState();

    const getApiServer = () => {
        if (WhichEnv === 'aws') {
            return 'https://api-us.turbosteed.com';
        }
        else {
            return `https://${process.env.REACT_APP_HOST_URL}`;
        }
    }

    useEffect(() => {
        console.trace("Here I am too! in useEffect");
        //console.log(useLocation());

        if (isMounted.current == false) {
            isMounted.current = true;
        }
        else {
            Tdebug && console.log("StAuthCallback already mounted!");
            return;
        }

        console.log("Now trying to authenticate with the server");
        fetchServerTokens(authCode);


    }, []);

    //var stack = new Error().stack
    //console.log( stack )
    console.trace("Here I am!");

    const fetchServerTokens = async (authCode) => {

        try {

            const response = await fetch(getApiServer() + '/auth', //new URLSearchParams({code: authCode}).toString(), 
                {
                    //method: 'GET',
                    method: 'POST',

			
			/*
                    body: JSON.stringify({
			    'authCode': authCode,
		    	    'up': ''   // Keep the utm params empty for now.
		    }),
		    */
		    
		    body: JSON.stringify(authCode),
                    withCredentials: 'true',     // Browser will send the cookies along with the request.
                    credentials: 'include',
                    //body: authCode,
                    headers: {
                        //'Access-Control-Allow-Origin': 'http://localhost:3000', 
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    console.log(response);
                    console.log(response.headers);
                    console.log(response.data);
                    console.log(JSON.stringify(response));

                    if (response.ok == false) {
                        throw new Error(response.json());
                    }

                    return response.json();
                }).then(async (responseJson) => {
                    Tdebug && console.log(responseJson);

                    if ((responseJson.uDet === undefined) ||
                        (responseJson.etac === undefined) ||
                        (responseJson.acctSid === undefined)) {
                        throw new Error('Invalid response');
                    }

                    let acct = responseJson.acctSid;
                    let encAuth = responseJson.etac;

                    loginAction(acct, encAuth);

                    Tdebug && console.log("Login successful, now store the necessary data");
                    Tdebug && console.log(responseJson.uDet);
                    Tdebug && console.log(JSON.stringify(responseJson.uDet));

                    // If the user has sites, then navigate to the dashboard, or else navigate to the site.
                    let navigateToSites = false;

                    localStorage.setItem('uDet', JSON.stringify(responseJson.uDet));

                    let curSiteIdx = 0;
                    if (responseJson.uDet.sites.length > 0) {

                        let sitesList = [];

                        for (var ss = 0; ss < responseJson.uDet.sites.length; ss++) {
                            sitesList.push(responseJson.uDet.sites[ss].siteId);
                        }

                        Tdebug && console.log(sitesList);


                        localStorage.setItem("sites", JSON.stringify(responseJson.uDet.sites));
                        localStorage.setItem("curSite", responseJson.uDet.sites[curSiteIdx].siteName);
                        localStorage.setItem("curSiteIdx", curSiteIdx);
                        navigateToSites = true;
                    }

                    Tdebug && console.log("Now navigating to the appropriate page");

                    const sleep = ms => new Promise(r => setTimeout(r, ms));
                    await sleep(200);

                    if (navigateToSites == false) {
                        console.log("Navigating to the onboarding page");
                        navigate('/onboard', { replace: true });
                        //navigate('/' + responseJson.sites[0] + '/dashboard', {replace: true});

                    }
                    else {
                        navigate('/' + responseJson.uDet.sites[curSiteIdx].siteId + '/home', { replace: true });
                    }
                    //return response.json();
                }).catch((error) => {
                    Tdebug && console.log(error);
                    Tdebug && console.log(error.stack);
                    Tdebug && console.log("Login unsuccessful, do nothing for now!");

                    window.location.replace(loginURL);
                    logOut();


                });




            /* Does not work?
            console.log("fetchServerTokens: fetch returned: " + response);
            const data = response.json();
            console.log(data);
            console.log(data.result['access_token']);
            console.log(data.result['id_token']);
            */
            /*
            .then((res)=>{return res.json()}).then(data=>{}
            console.log('access token is:');
            console.log(data.result['access_token']);
            console.log('id token is:');
            console.log(data.result['id_token']);
            loginAction(data.result['access_token']);
            navigate('/dashboard', {replace: true});
            */
        } catch (e) {
            console.log("fetchServerTokens: error");
            console.log(e);
        }

        //setAuthRequested(false);
    }

    //console.log("StAuth: authRequested is" + authRequested);

    const authCode = new URLSearchParams(location.search).get('code');
    if ((authCode) && (!authRequested)) {
        //console.log("Now trying to authenticate with the server");
        //fetchServerTokens(authCode);
        //setAuthRequested(true);

    }
    const LoadingSpinner = {
        animation : "border",
        variant : "primary",
        size : null,
        text : "Loading...",
        className : ""
    }
    return (
        <div className={`d-flex flex-column align-items-center justify-content-center p-3 ${LoadingSpinner.className}`} style={{height: '100vh'}}>
            <Spinner
                animation={LoadingSpinner.animation}
                variant={LoadingSpinner.variant}
                size={LoadingSpinner.size}
                role="status"
            >
                <span className="visually-hidden">{LoadingSpinner.text}</span>
            </Spinner>
            <div className="mt-2">
                <small className="text-muted">{LoadingSpinner.text}</small>
            </div>
        </div>
    )
}

export default StAuthCallback;
